<template>
  <div>
    <v-card class="card-custom-shadow mb-2">
      <v-card-text class="fs-12">
        <div class="fs-14px black--text mb-2">Rental [Thuê]</div>
        <v-row dense>
          <v-col cols="12">
            <v-text-field
              v-model.number="order.rent_day"
              class="c-input-small"
              dense
              outlined
              hide-details
              label="Rental days [Số ngày thuê]"
              type="number"
              @keypress="allowOnlyPositiveIntegers"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-autocomplete
              v-model="order.id_asset"
              class="c-input-small"
              :items="assetOptions"
              dense
              outlined
              hide-details
              label="Model [Mẫu xe]"
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="card-custom-shadow">
      <v-card-text class="fs-12">
        <div class="fs-14px black--text mb-2">Need Charger [Cần bộ sạc]?</div>
        <v-row dense>
          <v-col cols="12">
            <div class="">
              <v-radio-group
                v-model="order.count_charger"
                hide-details
                dense
                class="c-input-small mt-0 mb-1"
              >
                <v-row dense>
                  <v-col cols="6">
                    <v-radio label="Yes [Có]" :value="1"></v-radio>
                  </v-col>
                  <v-col cols="6">
                    <v-radio label="No [Không]" :value="0"></v-radio>
                  </v-col>
                </v-row>
              </v-radio-group>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { ORDER_CREATE_DEFAULT_PARTNER_ITEM } from "@/libs/const";

export default {
  name: "BookingItems",
  props: {
    info: {
      type: Object,
      default: () => {},
    },
    summary: {
      type: Object,
      default: () => {},
    },
    vouchers: {
      type: Array,
      default: () => [],
    },
    assets: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    order: { ...ORDER_CREATE_DEFAULT_PARTNER_ITEM },
    code: null,
    isLoading: false,
  }),
  computed: {
    assetOptions() {
      return [...this.assets].map((asset) => ({
        text: asset.name,
        value: asset.id,
      }));
    },
    scannedCodes() {
      if (!this.order.items || this.order.items.length === 0) {
        return [];
      }

      return [...this.order.items].map((item) => item.code);
    },
    voucherOptions() {
      if (!this.vouchers || this.vouchers.length === 0) {
        return [];
      }

      return [...this.vouchers].map((voucher) => ({
        text: `${voucher.code} - ${voucher.name}`,
        value: voucher.id,
      }));
    },
  },
  watch: {
    order: {
      handler() {
        this.$emit("onUpdate", this.order);
      },
      deep: true,
    },
  },
  mounted() {
    if (this.info && this.info.id) {
      console.log(this.info);
      console.log("assetOptions", this.assetOptions);
      this.order = {
        ...this.order,
        id_asset: this.info.id_asset,
        rent_day: this.info.rent_day,
        note: this.info.note,
        count_charger: this.info.count_charger,
      };
    } else {
      setTimeout(() => {
        this.setDefaultAsset();
      }, 2000);
    }
  },
  methods: {
    onReset() {
      this.order = { ...ORDER_CREATE_DEFAULT_PARTNER_ITEM };
    },
    setDefaultAsset() {
      this.order = {
        ...this.order,
        id_asset:
          this.assetOptions &&
          this.assetOptions[0] &&
          this.assetOptions[0].value,
      };
    },
  },
};
</script>
